/** Public removal error shared with the console; provider details never leave the API. */
export const DEVICE_REMOVAL_REMOTE_UNAVAILABLE_CODE = 'device_removal_remote_unavailable';
export const DEVICE_REMOVAL_REMOTE_UNAVAILABLE_MESSAGE =
  'Device removal requires WITTCO Remote to be running. Try again after WITTCO Remote is available.';
